import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useLoadingWheelStyles = makeStyles({
    loader: {
        ...shorthands.border('16px', 'solid', tokens.colorBrandBackground2),
        ...shorthands.borderTop('16px', 'solid', tokens.colorBrandForegroundLink),
        ...shorthands.borderRadius('50%'),
        width: '120px',
        height: '120px',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    animation: {
        animationIterationCount: 'infinite',
        animationTimingFunction: 'linear',
        animationDuration: '2s',
        animationName: {
            from: { transform: 'rotate(0deg)' },
            to: { transform: 'rotate(360deg)' }
        }
    }
});
